import * as ActionType from "./loggedUser.type";
import jwt_decode from "jwt-decode";

const initialState = {
  profile: null,
  tokenData: null,
};

export const loggedUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.DECODE_TOKEN:
      const token = sessionStorage.getItem("token");
      const decodedToken = token ? jwt_decode(token) : null;

      return {
        ...state,
        tokenData: decodedToken,
      };
    case ActionType.GET_LOGGED_USER:
      return {
        ...state,
        profile: action.payload,
      };
    case ActionType.UPDATE_USER_DETAILS:
      return {
        ...state,
        profile: action.payload,
      };
    default:
      return state;
  }
};
